import React, { Component } from 'react';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import qs from 'qs';
import { Button } from 'antd';
import routes from '@achievable-me/tundra-wizard/routes';
import AuthLayout from '$components/layout/AuthLayout';
import SpinnerError from '$components/library/SpinnerError';
import Seo from '$components/Seo';

const TALK_SSO = gql`
  query TalkSso($input: TalkSsoInput!) {
    talkSso(input: $input) {
      redirectTo
    }
  }
`;

class TalkSso extends Component {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const { search } = location;
    const query = search.substring(1);
    const parsed = qs.parse(query);

    const { sso, sig } = parsed;

    this.state = {
      sso,
      sig,
    };
  }

  render() {
    const { sso, sig } = this.state;

    return (
      <AuthLayout>
        <Seo
          title="Achievable community signin"
          canonical={routes.auth.talkSso}
          description="Sign in to your Achievable account."
        />
        <Query query={TALK_SSO} variables={{ input: { sso, sig } }}>
          {({ data, loading, error }) => {
            if (loading) {
              return <SpinnerError />;
            }

            if (error) {
              return (
                <div>
                  <div>An error occured, please try again.</div>
                  <br />
                  <a href="https://talk.achievable.me">
                    <Button type="primary">Visit Achievable community</Button>
                  </a>
                </div>
              );
            }

            const {
              talkSso: { redirectTo },
            } = data;
            window.location = redirectTo;

            return <SpinnerError />;
          }}
        </Query>
      </AuthLayout>
    );
  }
}

export default TalkSso;
